export const getCsrfToken = () => {
  // @ts-ignore
  return document.querySelector("[name=csrf-token]").attributes["content"].value;
};

export default getCsrfToken;